import React, { useEffect, useRef, useState } from 'react';

const ContactFormWidget = () => {
  const iframeRef = useRef(null);
  const [iframeHeight, setIframeHeight] = useState('400px'); // Start-Höhe

  const src = "https://portal.reonic.de/public/f201155a-4f11-4a9a-ae52-5b14e19c3e65/contact?direct=contact";

  // Resize-Funktion
  const resizeIframe = () => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    try {
      const iframeBody = iframe.contentWindow.document.body;
      const newHeight = iframeBody.scrollHeight;
      if (newHeight) setIframeHeight(newHeight + 'px');
    } catch (err) {
      // Cross-Origin Fehler ignorieren
      // Reonic erlaubt Cross-Origin Messages nicht, daher feste Höhe verwenden
    }
  };

  useEffect(() => {
    const iframe = iframeRef.current;
    if (!iframe) return;

    // Resize beim Load
    iframe.addEventListener('load', resizeIframe);

    // Resize bei Fenstergröße ändern
    window.addEventListener('resize', resizeIframe);

    return () => {
      iframe.removeEventListener('load', resizeIframe);
      window.removeEventListener('resize', resizeIframe);
    };
  }, []);

  return (
    <div className="w-full">
      <iframe
        ref={iframeRef}
        title="Energyhouse"
        src={src}
        style={{
          width: '100%',
          height: iframeHeight,
          border: '0',
          minHeight: '800px',
        }}
        sandbox="allow-scripts allow-same-origin allow-popups"
      />
    </div>
  );
};

export default ContactFormWidget;
